module.exports = __webpack_public_path__ + "img/avatar-9.2a3fe46e.png";